import { tv, type VariantProps } from 'tailwind-variants';
export type AtNavLinkVariants = VariantProps<typeof atNavLink>;

const atNavLink = tv({
  base: 'group',
  slots: {},
  variants: {
    size: {
      sm: '',
      lg: '',
    },
    type: {
      menu: 'nav-link-menu-base',
      cta: 'nav-link-cta-base cta-text-lg',
      inline: 'nav-link-inline-base',
    },
    selected: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      type: 'menu',
      className: 'paragraph-md',
    },
    {
      size: 'lg',
      type: 'menu',
      className: 'paragraph-md md:paragraph-lg',
    },
    {
      size: 'sm',
      type: 'inline',
      className: 'link-text-sm',
    },
    {
      size: 'lg',
      type: 'inline',
      className: 'link-text-lg',
    },
    {
      type: 'cta',
      selected: true,
      className: 'nav-link-cta-selected',
    },
    {
      type: 'cta',
      selected: false,
      className:
        'focus:outline-[2px] focus:outline focus:outline-navLink-focus',
    },
  ],
});

export default atNavLink;
